<script>
    import {External, M} from "../../external";

</script>

<div style="display: flex; flex-direction: row; height: 100%;">

    <div class="account-settings col20" style="height: auto;">
        <div class="top-background-wrapper narrow-top-background dash-top-background" >
            <div class="top-background">
                <div class="text-wrapper flex align-center flex-col-mobile align-left-mobile col20 f-left">
                    <h1 class="members-title f-left t-center" style="margin-bottom: 0px;">Circles Dashboard</h1>
                    <div class="flex align-center">
                        <div class="f-left">
                            <div class="custom-dropdown">
                                <div class="flex align-center custom-dropdown-button circle-effect"><span class="material-icons date-range-icon">date_range</span> Last 7 days <span class="material-icons">keyboard_arrow_down</span></div>
                            </div>
                        </div>
                        <h4 class="ml-15 hide-mobile">for</h4>
                        <div class="custom-dropdown ml-15">
                            <div class="flex align-center custom-dropdown-button circle-effect">All Circles <span class="material-icons">keyboard_arrow_down</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-wrapper">
            <div class="sections-wrapper profile-inner-wrapper bg-white box-shadow" style="overflow:hidden;">
                <div class="upper-navigation upper-navigation-full mt-15">
                    <ul>
                        <li><a class="active">Overview</a></li>
                        <li><a class="">Content</a>
                    </ul>
                </div>


                <div class="padding-45 f-left col20">
                    <div class="upper-navigation upper-navigation-full inner-upper-nav mb-25">
                        <ul>
                            <li><a class="active">Tracked Content</a></li>
                            <li><a class="">Paid Content</a></li>
                        </ul>
                    </div>

                    <div class="scrollable-table orders-scrollable-tablee scrollable-table-design strnger-border multi-level-table mb-25">
                        <table style="margin-top: 0px;">
                            <thead>
                            <tr class="flex flex-row align-center" style="padding-bottom: 0px;">
                                <td class="checkbox-table"></td>
                                <th class="flex-none mw-240" style="padding-left: 20px;"><a>Circle Name</a></th>
                                <th class="flex-none mw-180">Price</th>
                                <th class="flex-none mw-180">Purchase Rate</th>
                            </tr>
                            </thead>
                            <tbody style="height: auto;">
                            <div class="collapsible svelte-8knux">
                                <tr class="flex flex-row align-center mb-0 mt-10">
                                    <td class="checkbox-table"><a class="table-expand-btn"><span class="material-icons-outlined">do_not_disturb_on</span></a></td>
                                    <td class="flex-none mw-240" style="padding-left: 20px;">Circle Name</td>
                                    <td class="flex-none mw-180">$19</td>
                                    <td class="flex-none mw-180">
                                        <div class="table-bar-outer">
                                            <div class="table-bar" style="width: 71.8%"></div>
                                            <span class="table-bar-label">71.8% - 5,620</span>
                                        </div>
                                    </td>
                                </tr>
                                <div class="contents" hidden="">
                                    <tr class="inner-table-wrapper">
                                        <td>
                                            <table class="inner-table" style="margin-top: 0px;">
                                                <thead>
                                                <tr class="flex flex-row align-center" style="padding-bottom: 0px;">
                                                    <th class="checkbox-table"></th>
                                                    <th class="flex-none mw-240" style="padding-left: 20px;"><a>Name</a></th>
                                                    <th class="flex-none mw-180">Price</th>
                                                    <th class="flex-none mw-120">Type</th>
                                                    <th class="flex-none mw-180">Purchase Rate</th>
                                                    <th class="flex-none mw-80"></th>
                                                </tr>
                                                </thead>
                                                <tbody style="height: auto;">
                                                <tr class="flex flex-row align-center inner-table-row" data-id="99">
                                                    <td class="checkbox-table"></td>
                                                    <td class="flex-none mw-240" style="padding-left: 20px;">Page Name</td>
                                                    <td class="flex-none mw-180">$9</td>
                                                    <td class="flex-none mw-120">Page</td>
                                                    <td class="flex-none mw-180">
                                                        <div class="table-bar-outer">
                                                            <div class="table-bar" style="width: 21.8%"></div>
                                                            <span class="table-bar-label">21.8% - 5,620</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="flex flex-row align-center inner-table-row" data-id="99">
                                                    <td class="checkbox-table"></td>
                                                    <td class="flex-none mw-240" style="padding-left: 20px;">Inner Circle Name</td>
                                                    <td class="flex-none mw-180">$9/month</td>
                                                    <td class="flex-none mw-120">Inner Circle</td>
                                                    <td class="flex-none mw-180">
                                                        <div class="table-bar-outer">
                                                            <div class="table-bar" style="width: 21.8%"></div>
                                                            <span class="table-bar-label">21.8% - 5,620</span>
                                                        </div>
                                                    </td>
                                                    <td class="flex-none mw-100"></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </div>
                            </div>
                            </tbody>
                        </table>
                    </div>


                    <div class="scrollable-table orders-scrollable-tablee scrollable-table-design strnger-border multi-level-table mb-25">
                        <table style="margin-top: 0px;">
                            <thead>
                            <tr class="flex flex-row align-center" style="padding-bottom: 0px;">
                                <td class="checkbox-table"></td>
                                <th class="flex-none mw-240" style="padding-left: 20px;"><a>Circle Name</a></th>
                                <th class="flex-none mw-120"><a>Members</a></th>
                                <th class="flex-none mw-180"><a>Completion Rate</a></th>
                            </tr>
                            </thead>
                            <tbody style="height: auto;">
                            <div class="collapsible svelte-8knux">
                                <tr class="flex flex-row align-center mb-0 mt-10">
                                    <td class="checkbox-table"><a class="table-expand-btn"><span class="material-icons-outlined">do_not_disturb_on</span></a></td>
                                    <td class="flex-none mw-240" style="padding-left: 20px;">Circle Name</td>
                                    <td class="flex-none mw-120">7,320</td>
                                    <td class="flex-none mw-180">
                                        <div class="table-bar-outer">
                                            <div class="table-bar" style="width: 71.8%"></div>
                                            <span class="table-bar-label">71.8% - 5,620</span>
                                        </div>
                                    </td>
                                </tr>
                                <div class="contents" hidden="">
                                    <tr class="inner-table-wrapper">
                                        <td>
                                            <table class="inner-table" style="margin-top: 0px;">
                                                <thead>
                                                <tr class="flex flex-row align-center" style="padding-bottom: 0px;">
                                                    <th class="checkbox-table"></th>
                                                    <th class="flex-none mw-240" style="padding-left: 20px;"><a>Name</a></th>
                                                    <th class="flex-none mw-180">Completion Rate</th>
                                                    <th class="flex-none mw-80"></th>
                                                </tr>
                                                </thead>
                                                <tbody style="height: auto;">
                                                <tr class="flex flex-row align-center inner-table-row" data-id="99">
                                                    <td class="checkbox-table"></td>
                                                    <td class="flex-none mw-240" style="padding-left: 20px;">Page</td>
                                                    <td class="flex-none mw-180">
                                                        <div class="table-bar-outer">
                                                            <div class="table-bar" style="width: 21.8%"></div>
                                                            <span class="table-bar-label">21.8% - 5,620</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="flex flex-row align-center inner-table-row" data-id="99">
                                                    <td class="checkbox-table"></td>
                                                    <td class="flex-none mw-240" style="padding-left: 20px;">Page</td>
                                                    <td class="flex-none mw-180">
                                                        <div class="table-bar-outer">
                                                            <div class="table-bar" style="width: 21.8%"></div>
                                                            <span class="table-bar-label">21.8% - 5,620</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="flex flex-row align-center inner-table-row" data-id="99">
                                                    <td class="checkbox-table"></td>
                                                    <td class="flex-none mw-240" style="padding-left: 20px;"><b class="inner-circle-separator">Inner Circle Name ↓</b></td>
                                                    <td class="flex-none mw-180">
                                                        <div class="table-bar-outer">
                                                            <div class="table-bar" style="width: 71.8%"></div>
                                                            <span class="table-bar-label">71.8% - 5,620</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="flex flex-row align-center inner-table-row" data-id="99">
                                                    <td class="checkbox-table"></td>
                                                    <td class="flex-none mw-240" style="padding-left: 20px;">Page</td>
                                                    <td class="flex-none mw-180">
                                                        <div class="table-bar-outer">
                                                            <div class="table-bar" style="width: 21.8%"></div>
                                                            <span class="table-bar-label">21.8% - 5,620</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="flex flex-row align-center inner-table-row" data-id="99">
                                                    <td class="checkbox-table"></td>
                                                    <td class="flex-none mw-240" style="padding-left: 20px;">Page</td>
                                                    <td class="flex-none mw-180">
                                                        <div class="table-bar-outer">
                                                            <div class="table-bar" style="width: 21.8%"></div>
                                                            <span class="table-bar-label">21.8% - 5,620</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="flex flex-row align-center inner-table-row" data-id="99">
                                                    <td class="checkbox-table"></td>
                                                    <td class="flex-none mw-240" style="padding-left: 20px;"><b class="inner-circle-separator">Inner Circle Name ↓</b></td>
                                                    <td class="flex-none mw-180">
                                                        <div class="table-bar-outer">
                                                            <div class="table-bar" style="width: 71.8%"></div>
                                                            <span class="table-bar-label">71.8% - 5,620</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="flex flex-row align-center inner-table-row" data-id="99">
                                                    <td class="checkbox-table"></td>
                                                    <td class="flex-none mw-240" style="padding-left: 20px;">Page</td>
                                                    <td class="flex-none mw-180">
                                                        <div class="table-bar-outer">
                                                            <div class="table-bar" style="width: 21.8%"></div>
                                                            <span class="table-bar-label">21.8% - 5,620</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="flex flex-row align-center inner-table-row" data-id="99">
                                                    <td class="checkbox-table"></td>
                                                    <td class="flex-none mw-240" style="padding-left: 20px;">Page</td>
                                                    <td class="flex-none mw-180">
                                                        <div class="table-bar-outer">
                                                            <div class="table-bar" style="width: 21.8%"></div>
                                                            <span class="table-bar-label">21.8% - 5,620</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </div>
                            </div>
                            </tbody>
                        </table>
                    </div>
                </div>


                <div class="padding-45 f-left col20" style="padding-top: 25px;">
                    <div class="flex col20 f-left store-section-analytics-warapper double-row-analytics flex-col-mobile" style="margin-top: 0px; background: #f5f6fa;">
                        <div class="analytics-box analytics-box-small col5">
                            <h3 class="flex align-center">New Enrolled Members <span class="chart-color ml-10" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span></h3>
                            <h2 class="col20 f-left f-28 gray-text"><b>0</b></h2>
                        </div>
                        <div class="analytics-box analytics-box-small">
                            <h3 class="flex align-center">
                                New Paying Members
                                <span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
                                      info
                                      <span class="none-soft hidden-info">
                                        <h4>New Paying Members</h4>
                                        <span>The newly generated paying members in your circle.</span>
                                      </span>
                                    </span>
                                <span class="chart-color ml-10" style="background: rgb(255, 152, 0) none repeat scroll 0% 0%"></span>
                            </h3>
                            <h2 class="col20 f-left f-28 gray-text"><b>0 <span class="decrease none">5 (83.3%) lifetime</span></b></h2>
                        </div>
                        <div class="analytics-box analytics-box-small">
                            <h3 class="flex align-center">
                                Revenue
                                <span class="chart-color ml-10" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>
                            </h3>
                            <h2 class="col20 f-left f-28 gray-text"><b>$0.00</b><span>(32 Orders)</span></h2>
                        </div>
                        <div class="analytics-box analytics-box-small col5">
                            <h3 class="flex align-center">Circle Completion</h3>
                            <h2 class="col20 f-left f-28 gray-text"><b>0</b></h2>
                        </div>
                        <div class="analytics-box analytics-box-small">
                            <h3 class="flex align-center">
                                ARPU
                                <span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
                                  info
                                  <span class="none-soft hidden-info">
                                    <h4>Average Revenue Per User</h4>
                                    <span>ARPU shows you how much is your average revenue per user.</span>
                                  </span>
                                </span>
                            </h3>
                            <h2 class="col20 f-left f-28 gray-text"><b>$77.00</b></h2>
                        </div>
                    </div>
                    <div class="flex f-left col20 mt-25 flex-col-mobile">
                        <div class="analytics-box-big col20 no-bpadding-mobile">
                            <h2 class="col20 f-left f-28 gray-text">Members and Revenue</h2>
                            <div class="col20 f-left relative mt-25 modern-chart-box">
                                <canvas style="display: block; box-sizing: border-box; height: 330px; width: 660px;" width="660" height="330"></canvas>
                                <div class="axis">
                                    <div class="tick"><span class="tick-label">27 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
                                    <div class="tick"><span class="tick-label">28 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
                                    <div class="tick"><span class="tick-label">29 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$20.00</span> </div>
                                    <div class="tick"><span class="tick-label">30 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
                                    <div class="tick"><span class="tick-label">31 May</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
                                    <div class="tick"><span class="tick-label">1 Jun</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
                                    <div class="tick"><span class="tick-label">2 Jun</span> <span class="value value-first flex align-center with-color"><span class="chart-color" style="background: rgb(61, 166, 255) none repeat scroll 0% 0%;"></span>0</span> <span class="value value-second flex align-center with-color"><span class="chart-color" style="background: rgb(249, 127, 127) none repeat scroll 0% 0%;"></span>$0.00</span> </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Bottom Stats Lane -->

                    <div class="flex col20 mt-25 f-left store-section-analytics-warapper flex-col-mobile double-row-analytics" style="background: #f5f6fa;">
                        <div class="analytics-box analytics-box-small">
                            <h3 class="flex align-center">
                                New Subscribers
                            </h3>
                            <h2 class="col20 f-left f-28 gray-text"><b>13</b></h2>
                        </div>
                        <div class="analytics-box analytics-box-small">
                            <h3 class="flex align-center">
                                Cancelations (Churn)
                                <span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
                                info
                                <span class="none-soft hidden-info">
                                  <h4>Cancelations (Churn)</h4>
                                  <span>The total amount of subscriptions that were cancelled in the selected period.</span>
                                </span>
                              </span>
                            </h3>
                            <h2 class="col20 f-left f-28 gray-text"><b>13</b></h2>
                        </div>
                        <div class="analytics-box analytics-box-small">
                            <h3 class="flex align-center">
                                Total MRR
                                <span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;">
                                info
                                <span class="none-soft hidden-info">
                                  <h4>Monthly Recurring Revenue</h4>
                                  <span>The total amount monthly recurring revenue from subscriptions.</span>
                                </span>
                              </span>                                </h3>
                            <h2 class="col20 f-left f-28 gray-text"><b>$8,452.00 </b><span>(52 Subscribers)</span></h2>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- Getting Started
    <div class="account-settings col20" style="height: auto;">
        <div class="top-background-wrapper narrow-top-background dash-top-background" style="padding-top: 15px;"><div class="top-background"></div></div>
        <div class="content-wrapper">
            <div class="sections-wrapper profile-inner-wrapper bg-white box-shadow" style="margin-bottom: 60px;overflow:hidden;">
                <div class="col20 f-left getting-started-layout getting-started-layout-big flex flex-col v2">
                    <div class="col20 f-left flex flex-row flex-col-mobile justify-center mb-25">
                        <div class="col11 f-left flex justify-center flex-col">
                            <h4 class="col20 f-left"><span>{M.GETTING_STARTED}</span></h4>
                            <h1 class="col20 f-left mt-10 mb-15">Start Your Community Circles</h1>
                            <span class="col20 f-left paragraph-text mb-10">With the Circles functionality you can start your membership areas, build your courses, meanage members, organize content, and have paywalls to access that content.</span>
                            <div class="col20 f-left mt-15"><a href="" class="big-button with-icon blue">Create A Circle</a></div>
                        </div>
                        <div class="col9 f-left justify-center align-center flex">
                            <div class="col20 f-left justify-center align-center flex flex-col store-getting-started">
                                <div class="col20 f-left gray-section product-select-wrapper">
                                    <div class="col20 f-left ab-step center-vertically">
                                        <div class="small-circle-icon"><span class="material-icons-outlined"> hdr_weak </span></div>
                                        <div>
                                            <h4 class="roboto">Create A Circle</h4>
                                            <span class="light-gray-text mt-5 ml-0">{M.SMALL_PERIOD_EXAMPLE}</span>
                                        </div>
                                        <a on:click={addCircleFromDashboard} class="text-link blue-text" rel="tab">{M.CREATE}</a>
                                    </div>
                                </div>
                                <div class="col20 f-left gray-section product-select-wrapper">
                                    <div class="col20 f-left ab-step center-vertically">
                                        <div class="small-circle-icon"><span class="material-icons-outlined"> credit_card </span></div>
                                        <div>
                                            <h4 class="roboto">{M.CONNECT_PROCESSOR}</h4>
                                            <span class="light-gray-text mt-5 ml-0">{M.SMALL_PERIOD_EXAMPLE}</span>
                                        </div>
                                        <a class="text-link blue-text" rel="tab" href="/me/store/settings#payments">{M.CONNECT}</a>
                                    </div>
                                </div>
                                <div class="col20 f-left gray-section product-select-wrapper">
                                    <div class="col20 f-left ab-step center-vertically">
                                        <div class="small-circle-icon"><span class="material-icons-outlined"> account_circle  </span></div>
                                        <div>
                                            <h4 class="roboto">Add Members</h4>
                                            <span class="light-gray-text mt-5 ml-0">{M.SMALL_PERIOD_EXAMPLE}</span>
                                        </div>
                                        <a class="text-link blue-text" rel="tab" href="/me/store/settings">{M.ADD}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col12 f-left justify-center align-center flex mt-25">
                      <div class="col20 f-left">
                        <div style="padding:56.25% 0 0 0;position:relative;">
                          <iframe src="//fast.wistia.net/embed/iframe/8ndlwjsplu" style="position:absolute;top:0;left:0;width:100%;height:100%;" allowtransparency="true" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen="" mozallowfullscreen="" webkitallowfullscreen="" oallowfullscreen="" msallowfullscreen="" frameborder="0"></iframe><script src="//fast.wistia.net/assets/external/E-v1.js" async=""></script>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->
</div>

